import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const Header = styled.div`
  width: 100%;
  background: ${colors.WHITE};
  min-height: 20vh;
`;

export const HeaderContent = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  position: absolute;
  bottom: 1rem;
  right: 2rem;
`;

export const HeaderIcon = styled.div`
  border-radius: 1rem;
  background: ${colors.GRAY};
  height: 13vh;
  width: 13vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeaderInfo = styled.div`
  margin-left: 3rem;
`;

export const EvaluationTitle = styled.div`
  font-size: 1.6rem;
  font-family: metropolis;
  font-weight: bold;
  gap: 1.5rem;
  margin-bottom: 0.5rem;
`;

export const EvaluationSubTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.9rem;
  font-family: metropolis;
  gap: 4rem;
  font-weight: 600;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FiltersContainer = styled.div`
  width: 95%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const SearchContainer = styled.div`
  width: 40%;
`;

export const DropDownsContainer = styled.div`
  width: 60%;
  display: flex;
  justify-content: end;
`;

export const ImageIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 2rem;
  max-height: 2rem;
  position: relative;
`;

export const LocationInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
`;

export const saveButton = {
  width: '10rem',
  height: '2.5rem',
  borderRadius: '0.5rem',
  cursor: 'pointer',
  background: colors.WHITE,
  color: colors.BLACK,
  border: `0.1rem solid ${colors.GRAY}`,
  fontSize: '0.75rem',
  fontFamily: 'metropolis',
  fontWeight: 'bold',
};

export const publishButton = {
  width: '10rem',
  height: '2.5rem',
  borderRadius: '0.5rem',
  cursor: 'pointer',
  background: colors.GREEN_LEAF,
  fontSize: '0.75rem',
  fontFamily: 'metropolis',
  fontWeight: 'bold',
};

export const thumbnail = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '1rem',
};

export const gpsIcon = {
  color: colors.GRAY,
};

export const Icon = {
  width: '1.6rem',
  height: '1.6rem',
};

export const addressText = {
  fontFamily: 'metropolis',
  fontSize: '1.5vmin',
  fontWeight: 'bold',
  color: colors.GRAY_DARKER,
  wordBreak: 'break-word',
  paddingLeft: '0.3rem',
};

export const EditEvaluationIcon = styled.div`
  background: ${colors.GREEN_LEAF};
  display: flex;
  align-items: center;
  border-radius: 50%;
  padding: 0.4rem;
  cursor: pointer;
  top: 0rem;
  right: 3rem;
  position: absolute;
  margin-top: 2rem;
  color: ${colors.WHITE};
`;

export const disabledButton = {
  display: 'flex',
  height: '2.5rem',
  maxWidth: '25vw',
  borderRadius: '0.5rem',
  cursor: 'disabled',
  background: colors.WHITE,
  color: colors.BLACK,
  border: `0.1rem solid ${colors.GRAY}`,
  fontSize: '0.75rem',
  fontFamily: 'metropolis',
  fontWeight: 'bold',
  opacity: '0.5',
};

export const disabledPublishButton = {
  display: 'flex',
  height: '2.5rem',
  maxWidth: '25vw',
  borderRadius: '0.5rem',
  cursor: 'disabled',
  background: colors.GRAY,
  fontSize: '0.75rem',
  fontFamily: 'metropolis',
  fontWeight: 'bold',
};

export default {
  Header,
  HeaderContent,
  HeaderIcon,
  HeaderInfo,
  ButtonContainer,
  EvaluationTitle,
  EvaluationSubTitle,
  SearchContainer,
  Content,
  FiltersContainer,
  DropDownsContainer,
  publishButton,
  saveButton,
  thumbnail,
  gpsIcon,
  Icon,
  addressText,
  ImageIconContainer,
  LocationInfo,
  EditEvaluationIcon,
  disabledButton,
  disabledPublishButton,
};
